<template>
  <div>
    <div v-if="toast" class="mangopay-toast">{{ toast }}</div>
    <div v-if="user && isUserPro(user) && user.sca_status === 'required'" class="block block-warning">
      <img src="/static/images/icons/warning.svg" alt="Attention" class="icon" />
      <div>
        <p>Pour des raisons de réglementation bancaire européenne (directive <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=celex%3A32015L2366" target="eu-legal">PSD2</a>),
          il est désormais nécessaire de vous authentifier sur notre plateforme de paiement.</p>
        <p>
          Pour ce faire, vous allez être redirigé sur une page de notre partenaire Mangopay qui vous proposera
          plusieurs options pour vous authentifier, par exemple un code reçu par SMS ou par email.</p>
        <p>Cliquez ci-dessous pour lancer la procédure&nbsp;:</p>
        <ui-button w="300px" :loading="loadingUserSCA" @click="startUserSCA()">Commencer la procédure SCA</ui-button>
      </div>
    </div>
    <div v-else-if="user && isUserPro(user) && user.sca_status === 'proxy-required'" class="block block-warning">
      <img src="/static/images/icons/warning.svg" alt="Attention" class="icon" />
      <div>
        <p>Pour des raisons de réglementation bancaire européenne (directive <a href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=celex%3A32015L2366" target="eu-legal">PSD2</a>),
          notre plateforme de paiement partenaire Mangopay a renforcé ses contraintes de sécurité.</p>
        <p>
          Il est désormais nécessaire que vous autorisiez Cooloc à effectuer des opérations financières pour votre compte sur cette plateforme,
          vous allez donc être redirigé sur une page Mangopay qui vous demandera de valider cette autorisation.</p>
        <p>Cliquez ci-dessous pour lancer la procédure&nbsp;:</p>
        <ui-button w="300px" :loading="loadingUserConsentSCA" @click="startUserConsentSCA()">Commencer la procédure SCA</ui-button>
      </div>
    </div>
    <div v-else-if="user && isUserPro(user) && user.kyc_status === 'required'" class="block block-warning">
      <img src="/static/images/icons/warning.svg" alt="Attention" class="icon" />
      <div>
        <p>Pour des raisons de réglementation européenne anti-fraude, la vérification de votre identité (KYC) auprès de
          notre plateforme de paiement partenaire Mangopay doit être mise à jour.</p>
        <p>
          Sans cela, vos fonds seront bloqués et vous ne pourrez plus recevoir vos loyers.
          Vous allez être redirigé sur une page sécurisée de notre partenaire Mangopay
          pour vérifier votre identité.</p>
        <p>Cliquez ci-dessous pour lancer la procédure&nbsp;:</p>
        <ui-button w="300px" :loading="loadingUserKYC" @click="startUserKYC()">Commencer la procédure KYC</ui-button>
      </div>
    </div>
  </div>
</template>
<script>
import { registrationHelpers } from '@/main'

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingUserSCA: false,
      loadingUserConsentSCA: false,
      loadingUserKYC: false,
      toast: '',
      toastTimeout: null,
    }
  },
  mounted() {
    if (this.$route.query.controlStatus || this.$route.query.actionStatus) {
      if (this.$route.query.sca_bank_type && this.$route.query.controlStatus === 'VALIDATED') {
        const { controlStatus, actionStatus, sca_bank_id, sca_bank_type, ...query } = this.$route.query
        this.$router.replace({ query })
        this.doSaveSCA(sca_bank_id, sca_bank_type)
      } else if (this.$route.query.controlStatus === 'CREATED') {
        const { controlStatus, ...query } = this.$route.query
        this.$router.replace({ query })
        this.doSaveSCAConsent()
      } else {
        registrationHelpers.fetchDataUser(this, () => {
          const { controlStatus, actionStatus, ...query } = this.$route.query
          this.$router.replace({ query })
        })
      }
    } else if (this.$route.query.kycSession) {
      const { kycSession, ...query } = this.$route.query
      this.$router.replace({ query })
      this.doCheckKYC()
    }
  },
  beforeDestroy() {
    clearTimeout(this.toastTimeout)
  },
  methods: {
    isUserPro(user) {
      return user && (registrationHelpers.userTypes.is(user, 'proprio') ||
        (registrationHelpers.userTypes.is(user, 'coloc') && user.home && !user.home.is_coloc) ||
        registrationHelpers.userTypes.is(user, 'agent'))
    },
    showToast(message) {
      this.toast = message
      clearTimeout(this.toastTimeout)
      this.toastTimeout = setTimeout(() => {
        this.toast = ''
      }, 5000)
    },
    doSaveSCA(owner_type, owner_id) {
      return this.$http.post(`/api/bank_accounts?ownerType=${owner_type}&ownerID=${owner_id}&sca=true`, null)
        .then(res => {
          if (res.data.sca_redirect_url && res.data.sca_type === 'bank') {
            this.startBankSCA(res.data.sca_redirect_url)
          }
          return res
        })
    },
    doSaveSCAConsent() {
      return this.$http.post(`/api/users/${this.user.id}/sca`, null)
        .then(res => {
          this.user.sca_status = res.data.sca_status
          return res
        })
    },
    startBankSCA(sca_redirect_url) {
      const returnUrl = encodeURIComponent(window.location.href)
      window.location.href = `${sca_redirect_url}&returnUrl=${returnUrl}`
    },
    startUserSCA() {
      this.loadingUserSCA = true
      return this.$http.post('/api/mangopay/enroll-sca', null)
        .then(res => {
          if (res.data && res.data.sca_redirect_url) {
            const url = encodeURIComponent(window.location.href)
            window.location.href = `${res.data.sca_redirect_url}&returnUrl=${url}`
            // Keep the loader while redirecting
            return new Promise(() => {})
          }
        })
        .finally(() => {
          this.loadingUserSCA = false
        })
    },
    startUserConsentSCA() {
      this.loadingUserConsentSCA = true
      return this.$http.post('/api/mangopay/proxy-consent', null)
        .then(res => {
          if (res.data && res.data.sca_redirect_url) {
            const url = encodeURIComponent(window.location.href)
            window.location.href = `${res.data.sca_redirect_url}&returnUrl=${url}&lang=fr`
            // Keep the loader while redirecting
            return new Promise(() => {})
          }
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.error === 'already_active') {
            this.user.sca_status = 'active'
            this.showToast('Votre autorisation de paiement est déjà active.')
          } else {
            throw err
          }
        })
        .finally(() => {
          this.loadingUserConsentSCA = false
        })
    },
    startUserKYC() {
      this.loadingUserKYC = true
      const url = new URL(window.location.href)
      url.searchParams.set('kycSession', 'true')
      const returnUrl = encodeURIComponent(url.href)
      return this.$http.post('/api/mangopay/start-idv', { return_url: returnUrl })
        .then(res => {
          if (res.data && res.data.hosted_url) {
            window.location.href = res.data.hosted_url
            // Keep the loader while redirecting
            return new Promise(() => {})
          } else if (res.data) {
            // No session started: refresh the KYC status
            this.user.kyc_status = res.data.kyc_status
          }
        })
        .finally(() => {
          this.loadingUserKYC = false
        })
    },
    doCheckKYC() {
      return this.$http.post('/api/mangopay/check-kyc', null)
        .then(res => {
          if (res.data && typeof res.data.kyc_status !== 'undefined') {
            this.user.kyc_status = res.data.kyc_status
          }
          return res
        })
    },
  },
  components: {
    UiButton: require('@/ui/Button').default,
  },
}
</script>
<style lang="scss" scoped>
.mangopay-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  max-width: 90vw;
  padding: 12px 24px;
  border-radius: 6px;
  background: #2c3e50;
  color: white;
  font-size: 15px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}
</style>
